import {State} from '../../../reducers';
import {createSelector} from '@ngrx/store';
import * as fromEvent from './event.reducer';

export const selectEvents = (state: State) => state.events;

export const selectAllEvents = createSelector(selectEvents, (state: fromEvent.State) => state.events);
